import React from 'react';

const SignOutContext = React.createContext<SignOutContextType | null>(null);

export interface SignOutContextType {
  showModal: boolean;
  setShowModal: (v: boolean) => void;
  promptSignOut: () => void;
  closeSignOut: () => void;
  currentStep?: string;
  setStep: (v: string) => void;
}

export default SignOutContext;
